// extracted by mini-css-extract-plugin
module.exports = {"section":"Paypal-section_a1830305","title":"Paypal-title_09e186e3","row":"Paypal-row_a9fcad53"};